export default function calculateSize(Bytes) {
    const Kilobytes = (Bytes / 1000).toFixed(1)
    const Megabytes = (Kilobytes / 1000).toFixed(1)
    const Gigabytes = (Megabytes / 1000).toFixed(1)
    const Terabytes = (Gigabytes / 1000).toFixed(1)
    const Petabytes = (Terabytes / 1000).toFixed(1)
    return Kilobytes < 1000 ? Kilobytes + ' KB' : Megabytes < 1000 ? Megabytes + ' MB' : Gigabytes < 1000 ? Gigabytes + ' GB' : Terabytes < 1000 ? Terabytes + ' TB' : Petabytes + ' PB'
}


// WEBPACK FOOTER //
// ./src/components/CalculateSize/index.js